<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container" :class="{ forgotPasswordContainer: forgotPassword }">
        <div class="modal-close" @click="closeModal()">&#10799;</div>
        <div class="content">
          <div class="top-information">
            <div class="top-information-text">
              <div class="modal-header-date">
                <div class="modal-header">
                  <span v-if="item.title">{{ item.title }}</span>
                </div>
                <div class="modal-date">
                  <span v-if="item.date">{{ item.date }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-content">
            <span v-if="item.content" class="modal-content-text" v-html="item.content"></span>
            <div v-if="forgotPassword" class="forgot-password">
              <span>Your email address:</span>
              <input class="form-input" type="text" />
              <br />
              <button class="button-p card button-shadow" @click="resetPassword()">
                <span>Reset password</span>
              </button>
            </div>
            <div v-if="accountRegister" class="forgot-password">
              <div class="account-register-content">
                <span>
                  You will soon receive a confirmation email at this email (check your spam inbox):
                  <br>
                  <span class="email">{{ email }}</span>
                </span>
                <button class="button-p card button-shadow register-account" @click="closeModal()">
                  <span>Close</span>
                </button>
              </div>
            </div>
            <div v-if="accountVerified" class="forgot-password">
              <div class="account-register-content">
                <span>
                  Your Account is now verified! Time to enjoy our bots!
                </span>
                <button class="button-p card button-shadow register-account" @click="closeModal()">
                  <span>Close</span>
                </button>
              </div>
            </div>
            <div v-if="purchase" class="forgot-password">
              <div class="account-register-content">
                <div class="loading">
                  <loading :active="loading" />
                </div>
                <button v-if="!loading" class="button-p card button-shadow register-account" @click="toBotsOverview()">
                  <span>Go to bots overview</span>
                </button>
              </div>
            </div>
          </div>
          <div v-if="editExchangeAccount || deleteExchangeAccount" class="modal-content">
            <loading :active="isLoading" />
            <div v-if="editExchangeAccount && !isLoading">
              <label for>Connection name:</label>
              <input class="form-input" type="text" v-model="newExchangeName" />
              <div class="change-keys">
                <input class="change-keys-checkbox" id="newKeys" type="checkbox" v-model="changeKeys">
                <label class="change-keys-label" for="newKeys">Change API Keys</label>
              </div>
              <div v-if="changeKeys">
                <label v-if="hasSubAccount" for>Subaccount name:</label>
                <input v-if="hasSubAccount" class="form-input" type="text" v-model="newSubaccountName " />
                <label for>API Key:</label>
                <input class="form-input" type="text" v-model="newExchangeAPIKey" />
                <label for>API Secret:</label>
                <input class="form-input" type="text" v-model="newExchangeAPISecret" />
                <label v-if="exchangePlatform === 'okx_futures' || 'bitget_futures'" for>Password:</label>
                <input v-if="exchangePlatform === 'okx_futures' || 'bitget_futures'" class="form-input" type="text" v-model="okxPassword" />
              </div>
              <span v-if="errMsg" class="error">{{ errMsg }}</span>
              <div v-if="!deleteExchangeAccount" class="confirm-buttons button-save-edit">
                <span class="button-p button-shadow" @click="editExchange()">Save</span>
                <span class="cancel-button" @click="closeModal()">Cancel</span>
              </div>
            </div>
            <div v-if="deleteExchangeAccount" class="confirm-buttons button-save-edit">
              <span class="button-p button-shadow" @click="deleteExchange()">Delete Account</span>
              <span class="cancel-button" @click="closeModal()">Cancel</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/shared/Loading.vue'
import { mapActions } from 'vuex'

export default {
  name: 'Modal',
  props: {
    item: Object,
    forgotPassword: {
      type: Boolean,
      default: false
    },
    accountRegister: {
      type: Boolean,
      default: false
    },
    email: String,
    purchase: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    editExchangeAccount: {
      type: Boolean,
      default: false
    },
    deleteExchangeAccount: {
      type: Boolean,
      default: false
    },
    accountVerified: {
      type: Boolean,
      default: false
    },
    exchangeAccount: Object,
    exchange: String
  },
  components: {
    Loading
  },
  data() {
    return {
      newExchangeName: '',
      newSubaccountName: '',
      changeKeys: false,
      newExchangeAPIKey: '',
      newExchangeAPISecret: '',
      errMsg: '',
      isLoading: false,
      hasSubAccount: false,
      exchangePlatform: '',
      okxPassword: ''
    }
  },
  mounted() {
    if (this.exchangeAccount) {
      this.exchangePlatform = this.exchangeAccount.exchange
      this.newExchangeName = this.exchangeAccount.connection_name
      if (this.exchangeAccount.subaccount_name) {
        this.newSubaccountName = this.exchangeAccount.subaccount_name
        this.hasSubAccount = true
      }
    }
  },
  methods: {
    ...mapActions(['addNewExchange']),
    closeModal() {
      this.$emit('click')
    },
    resetPassword() {
      this.$emit('click')
    },
    toBotsOverview() {
      this.closeModal()
      this.$router.push({ name: 'Bots', params: { page: 'subscribed' } })
    },
    deletePaymentMethod() {
      this.$emit('deleteMethod')
    },
    editExchange() {
      this.isLoading = true
      this.errMsg = ''
      const body = {
        connection_name: this.newExchangeName,
        exchange: this.exchange,
        connection_id: this.exchangeAccount.connection_id,
        user_id: this.$session.get('uid')
      }
      if (this.hasSubAccount) {
        body.subaccount_name = this.newSubaccountName
      }
      if (this.changeKeys && this.exchangePlatform === 'okx_futures' || 'bitget_futures') {
        body.password = this.okxPassword
      }

      if (this.newExchangeAPIKey !== '' && this.newExchangeAPISecret !== '') {
        body.api_key = this.newExchangeAPIKey
        body.api_secret = this.newExchangeAPISecret
      }

      this.$api
        .post('/exchanges/edit_connection', body, {
          headers: {
            'X-Authorization': this.$session.get('token')
          }
        })
        .then((res) => {
          if (res.status === 200) {
            this.isLoading = false
            this.closeModal()
            this.$emit('edit')
          }
        })
        .catch((err) => {
          this.isLoading = false
          if (err.response.data.error.type === 'Could not validate credentials') {
            this.$session.destroy()
            this.$router.push({ name: 'Login' })
          }
          if (err.response.data.error.type === 'DUPLICATE_VALUE') {
            this.errMsg = err.response.data.error.body
          }
          if (err.response.data.error.type === 'CONNECTION_ERROR') {
            this.errMsg = err.response.data.error.body
          }
        })
    },
    deleteExchange() {
      this.$emit('deleteConnection', this.exchangeAccount)
      this.closeModal()
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.forgot-password {
  margin-top: 25px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.content {
  padding: 20px;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: auto;
  width: 700px;
  margin: 0 auto;
  padding: 10px;
  background-color: var(--background);
  box-shadow: 0 2px 8px var(--shadow);
  transition: all 0.3s ease;
  border-radius: 20px;
}

.forgotPasswordContainer {
  width: 600px;
}

.modal-close {
  margin-top: -20px;
  font-size: 40px;
  float: right;
  cursor: pointer;
}

.modal-header {
  vertical-align: middle;
  width: 80%;
  font-size: 28px;
  margin-top: 0;
}

.modal-date {
  font-size: 12px;
}

.modal-content {
  height: 100%;
  margin-top: 20px;
  font-size: 16px;
}

.modal-content-text {
  line-height: 200%;
  display: block; /* inline-block; */
  text-align: justify;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.email {
  color: var(--primary-blue);
  font-size: 20px;
}

.register-account {
  margin-top: 20px;
  bottom: 0;
}

.account-register-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-items {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card-item-title {
  font-weight: 600;
}

.delete-button {
  width: 100%;
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cancel-button {
  margin-left: 50px;
  color: var(--primary-blue);
  text-decoration: underline;
  font-weight: 500;
  font-size: 20px;

  cursor: pointer;
}

.button-save-edit {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.change-keys {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.change-keys-label {
  cursor: pointer;
  margin-left: 10px;
}

.change-keys-checkbox {
  cursor: pointer;
}

@media (max-width: 1200px) {
  .modal-container {
    width: 95%;
    height: auto;
    overflow-y: auto;
    padding: 15px;
  }

  .content {
    padding: 10px 0;
  }
}
</style>
